// extracted by mini-css-extract-plugin
module.exports = {"search-header":"search-header__3Z9mG","postCreating":"postCreating__1-JAX","warning":"warning__28hN8"};